import { createStore } from 'vuex'

export default createStore({
    state: {
        formModel: {},
        siteMetadata: {}
    },
    mutations: {
        setNewformModelProp (state, prop) {
            state.formModel[prop.name] = prop.value
        },
        setMetadata (state, val) {
            state.siteMetadata = val
        }
    },
    actions: {
        updateFormModel ({ commit }, data) {
            commit('setNewformModelProp', data)
        },
        updateMetaData ({ commit }, data) {
            commit('setMetadata', data)
        }
    },
    getters: {
        formModel: (state) => state.formModel,
        siteMetadata: (state) => state.siteMetadata
    },
    modules: {
    }
})
